import { z } from 'zod/v4'

// These labels are sent verbatim to Mixpanel and to the backend as the
// cancellation reason — treat them as stable identifiers; rewording one is a
// data-continuity decision, not just a copy change.
export const CANCELLATION_REASONS = [
  'Too expensive',
  'Missing features',
  'Stability or reliability issues',
  'Switching to another provider',
  'Project ended / no longer needed',
  'Other',
] as const

export type CancellationReason = (typeof CANCELLATION_REASONS)[number]

export const deleteCompanySchema = z
  .object({
    reason: z.enum(CANCELLATION_REASONS, 'Please select a reason'),
    reasonDetails: z
      .string()
      .trim()
      .max(500, 'Please keep it under 500 characters')
      .optional(),
    feedback: z
      .string()
      .trim()
      .max(1000, 'Please keep it under 1000 characters')
      .optional(),
    deleteAccount: z.boolean(),
    confirmName: z.string(),
  })
  .superRefine((values, ctx) => {
    const isMissingOtherDetails =
      values.reason === 'Other' && !values.reasonDetails
    if (isMissingOtherDetails) {
      ctx.addIssue({
        code: 'custom',
        path: ['reasonDetails'],
        message: 'Please tell us more about your reason',
      })
    }
  })

export type DeleteCompanyFormValues = z.infer<typeof deleteCompanySchema>
